module.exports = __webpack_public_path__ + "static/laws_mock-a1a1dafc1a5e4f8f244ca28292f7ab15.png";